import amplitude from "amplitude-js";

export const setUserIdAmplitude = (id) => {
  return amplitude.getInstance().setUserId(id);
};

export const setUserPropertiesAmplitude = (userObj) => {
  return amplitude.getInstance().setUserProperties(userObj);
};

export const firstLaunchEventAmplitude = (eventObj) => {
  return amplitude.getInstance().logEvent("first_launch", eventObj);
};

export const appOpenEventAmplitude = (eventObj) => {
  return amplitude.getInstance().logEvent("app_open", eventObj);
};

export const landingOpenEventAmplitude = (eventObj) => {
  return amplitude.getInstance().logEvent("landing_open", eventObj);
};

export const landingCompleteEventAmplitude = (eventObj) => {
  return amplitude.getInstance().logEvent("landing_complete", eventObj);
};

export const onBoardingStartEventAmplitude = (eventObj) => {
  return amplitude.getInstance().logEvent("onboarding_start", eventObj);
};

export const onboardingFillEventAmplitude = (eventObj) => {
  return amplitude.getInstance().logEvent("onboarding_fill", eventObj);
};

export const onboardingCompleteEventAmplitude = (eventObj) => {
  return amplitude.getInstance().logEvent("onboarding_complete", eventObj);
};

export const personalSleepPlanGenerateEventAmplitude = (eventObj) => {
  return amplitude
    .getInstance()
    .logEvent("personal_sleep_plan_generate", eventObj);
};

export const storeOpenEventAmplitude = (eventObj) => {
  return amplitude.getInstance().logEvent("store_open", eventObj);
};

export const loadGenerateEventAmplitude = (eventObj) => {
  return amplitude.getInstance().logEvent("lead_generate", eventObj);
};

export const paywallOpenEventAmplitude = (eventObj) => {
  return amplitude.getInstance().logEvent("paywall_open", eventObj);
};

export const paymentTypeEventAmplitude = (eventObj) => {
  return amplitude.getInstance().logEvent("paymentmethod_change", eventObj);
};

export const paymentInfoAddEventAmplitude = (eventObj) => {
  return amplitude.getInstance().logEvent("paymentinfo_add", eventObj);
};

export const checkoutInitiateEventAmplitude = (eventObj) => {
  return amplitude.getInstance().logEvent("checkout_initiate", eventObj);
};

export const trialStartEventAmplitude = (eventObj) => {
  return amplitude.getInstance().logEvent("trial_start", eventObj);
};

export const revenueAmplitude = (productId, quantity, price) => {
  var revenue = new amplitude.Revenue()
    .setProductId(productId)
    .setPrice(price)
    .setQuantity(quantity);
  return amplitude.getInstance().logRevenueV2(revenue);
};
